/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  RewardVault,
  RewardVaultInterface,
} from "../../contracts/RewardVault";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "_rewardToken",
        type: "address",
      },
      {
        internalType: "contract IRewardFeeder",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_claimsWhitelist",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "EnforcedPause",
    type: "error",
  },
  {
    inputs: [],
    name: "ExpectedPause",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "claimer",
        type: "address",
      },
    ],
    name: "RewardVault_ClaimNotAuthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardVault_FailedToSendReward",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardVault_FeederUnavailable",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardVault_IncorrectAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardVault_ZeroAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardVault_ZeroAvailable",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "available",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalReward",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct IRewardVault.ClaimData",
        name: "claimData",
        type: "tuple",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "stakingToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "totalClaimed",
        type: "uint256",
      },
    ],
    name: "DistributionFinished",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "stakingToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "totalFunded",
        type: "uint256",
      },
    ],
    name: "DistributionStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amountAdded",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "totalFunded",
        type: "uint256",
      },
    ],
    name: "Funded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "CLAIMS_WHITELIST",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FUNDER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SETTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "cachebackVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountToClaim",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claims",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeder",
    outputs: [
      {
        internalType: "contract IRewardFeeder",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "fundVault",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "getUserClaimData",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "available",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalReward",
            type: "uint256",
          },
        ],
        internalType: "struct IRewardVault.ClaimData",
        name: "claimData",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVaultData",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "totalFunded",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalClaimed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "feeder",
            type: "address",
          },
          {
            internalType: "address",
            name: "stakingToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "rewardToken",
            type: "address",
          },
        ],
        internalType: "struct IRewardVault.VaultData",
        name: "vaultData",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "claimer",
        type: "address",
      },
    ],
    name: "revokeClaimWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "claimer",
        type: "address",
      },
    ],
    name: "setClaimWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRewardFeeder",
        name: "_rewardFeeder",
        type: "address",
      },
    ],
    name: "setRewardFeeder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "_rewardToken",
        type: "address",
      },
    ],
    name: "setRewardToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "_stakingToken",
        type: "address",
      },
    ],
    name: "setStakingToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startDistributing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stopDistributing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokenTracking",
    outputs: [
      {
        internalType: "uint256",
        name: "totalFunded",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalClaimed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalFunded",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RewardVaultConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RewardVaultConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RewardVault__factory extends ContractFactory {
  constructor(...args: RewardVaultConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _stakingToken: AddressLike,
    _rewardToken: AddressLike,
    _feeder: AddressLike,
    _claimsWhitelist: boolean,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _stakingToken,
      _rewardToken,
      _feeder,
      _claimsWhitelist,
      overrides || {}
    );
  }
  override deploy(
    _stakingToken: AddressLike,
    _rewardToken: AddressLike,
    _feeder: AddressLike,
    _claimsWhitelist: boolean,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _stakingToken,
      _rewardToken,
      _feeder,
      _claimsWhitelist,
      overrides || {}
    ) as Promise<
      RewardVault & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): RewardVault__factory {
    return super.connect(runner) as RewardVault__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RewardVaultInterface {
    return new Interface(_abi) as RewardVaultInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): RewardVault {
    return new Contract(address, _abi, runner) as unknown as RewardVault;
  }
}
